// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1qprcsu-option {
    text-align: left;
    min-width: 95% !important;
    /* code added for width of dropdown */
}

.css-1vr111p-option {
    text-align: left;
    min-width: 95% !important;
    /* code added for width of dropdown */
}

.css-1r4vtzz {
    width: 100% !important;
}

.css-48ayfv {
    width: 100% !important;
}

/* code added for width of dropdown */
.css-48ayfv+div {
    width: 100%;
}

.css-1jllj6i-control {
    min-width: 95% !important;
}

.css-19t9a5b-control {
    min-width: 95% !important;
}

.css-vb64bg-control:hover {
    min-width: 95% !important;
}

.css-vb64bg-control {
    min-width: 95% !important;
}

.css-6y1x9t-control:hover {
    min-width: 95% !important;
}

.css-6y1x9t-control {
    min-width: 95% !important;
}

/* code added for width of dropdown */

input {
    height: inherit
}

.react-select__option {
    font-size: 80% !important;
}

.react-select__option1 {
    font-size: 100% !important;
}

.react-select__menu-list {
    max-height: 150px !important;
    -webkit-overflow-scrolling: auto !important;
}

.bus_filtr_btn {
    position: relative;
    top: 10px;
}

.font-bus-head {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
}

.font-bus-head_a {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
    text-align: left;
}

.font-bus-head_pg {
    font-size: 1.25rem !important;
    color: #000;
    font-weight: 600;
}

.filter_bus_icon {
    background: #fff !important;
    color: #83A4CF !important;
    padding: 0px 9px;
    font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/MileageSaarathiTab_ace/Filter/CustomSelect_Bus.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qCAAqC;;AAErC;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".css-1qprcsu-option {\n    text-align: left;\n    min-width: 95% !important;\n    /* code added for width of dropdown */\n}\n\n.css-1vr111p-option {\n    text-align: left;\n    min-width: 95% !important;\n    /* code added for width of dropdown */\n}\n\n.css-1r4vtzz {\n    width: 100% !important;\n}\n\n.css-48ayfv {\n    width: 100% !important;\n}\n\n/* code added for width of dropdown */\n.css-48ayfv+div {\n    width: 100%;\n}\n\n.css-1jllj6i-control {\n    min-width: 95% !important;\n}\n\n.css-19t9a5b-control {\n    min-width: 95% !important;\n}\n\n.css-vb64bg-control:hover {\n    min-width: 95% !important;\n}\n\n.css-vb64bg-control {\n    min-width: 95% !important;\n}\n\n.css-6y1x9t-control:hover {\n    min-width: 95% !important;\n}\n\n.css-6y1x9t-control {\n    min-width: 95% !important;\n}\n\n/* code added for width of dropdown */\n\ninput {\n    height: inherit\n}\n\n.react-select__option {\n    font-size: 80% !important;\n}\n\n.react-select__option1 {\n    font-size: 100% !important;\n}\n\n.react-select__menu-list {\n    max-height: 150px !important;\n    -webkit-overflow-scrolling: auto !important;\n}\n\n.bus_filtr_btn {\n    position: relative;\n    top: 10px;\n}\n\n.font-bus-head {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n}\n\n.font-bus-head_a {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n    text-align: left;\n}\n\n.font-bus-head_pg {\n    font-size: 1.25rem !important;\n    color: #000;\n    font-weight: 600;\n}\n\n.filter_bus_icon {\n    background: #fff !important;\n    color: #83A4CF !important;\n    padding: 0px 9px;\n    font-size: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
